(function () {
    'use strict';

    a3_cabin_reports.directive('twoLuggageEvents', twoLuggageEvents);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name twoLuggageEvents
    * @restrict E
    * @description
    *   Implementation of twoLuggageEvents
    * @example
    *   Usage:
    *   <two-luggage-events></two-luggage-events>
    * @ngInject
    */
    function twoLuggageEvents(LuggageComplianceFactory, PaxInfoFactory, $timeout) {
        function link(scope) {
            scope.submit = submit;
            scope.reset = resetConfirm;
            scope.resetSynced = resetSyncedConfirm;
            scope.allPassengersAreComplianceConfirmation = allPassengersAreComplianceConfirmation; 
            

            getLuggageCompliancePassengers();

            function getLuggageCompliancePassengers(){
                scope.hasSyncedPassengers = false;
                scope.Passengers = [];
                scope.pendingReports = [];
                var flightId = scope.flight.FlightId;

                scope.flightCompliant = LuggageComplianceFactory.getFlightCompliantStatus(flightId);
        
                //Get cabin luggage compliance reports for this flight
                var luggageComplianceReports = LuggageComplianceFactory.getLuggageComplianceByFlightId(flightId);

                //Get pax info
                PaxInfoFactory.getPaxInfoFromStorage(flightId, function (paxinfo) {
                    if(paxinfo){
                        luggageComplianceReports.forEach(function (luggageReport) {
                            var columns = [];
                            paxinfo.Seatmap.forEach(function(row){
                                row.Columns.forEach(function(column){
                                    columns.push(column);
                                });
                            });
    
                            var pax = columns.find(p => p.UCI == luggageReport.UCI);
                            if(pax){
    
                                //Passenger already exists - Only add events
                                if(scope.Passengers.map(p => p.UCI).includes(luggageReport.UCI)){
                                    scope.Passengers.find(p => p.UCI == luggageReport.UCI).isSynced = luggageReport.isSynced;
                                }
                                //Add Passenger Info & Events
                                else{
                                    var passenger = {
                                        UCI: luggageReport.UCI,
                                        isSynced : luggageReport.isSynced,
                                        Name : pax.Fullname,
                                        SeatNo : pax.SeatNo,
                                        HasTwoLuggage: true,
                                        isOpen: false
                                    };
                                    scope.Passengers.push(passenger);
                                }
                                if(scope.Passengers.some(x => x.isSynced)){
                                    scope.hasSyncedPassengers = true;
                                }
                            }
                        });
                    }

                    scope.pendingReports = scope.Passengers.filter(p => !p.isSynced);

                    //Get flightIsCompliant report
                    var flightIsCompliantReport = luggageComplianceReports.find(p => !p.isSynced && p.IsFlightCompliant);
                    if(flightIsCompliantReport){
                        scope.pendingReports.push(flightIsCompliantReport);
                    }
                });
            }

            /**
             * Opens confirmation modal when undo is requested on an approved proposal
             * @memberof proposal
             */
            function allPassengersAreComplianceConfirmation() {
                if(!scope.flightCompliant.HasPendingsReports){
                    applyAllPassengersAreCompliant();
                }
                else if (!scope.flightCompliant.IsFlightCompliant && scope.flightCompliant.HasPendingsReports){
                    bootbox.dialog({
                        message: '<i class="fa fa-exclamation-triangle text-orange"></i> All pending reports of passengers with 2 items on board will be cleared.',
                        title: "Confirm",
                        buttons: {
                            confirm:{
                                label: 'Confirm',
                                className: "btn-success",
                                callback: function(){
                                    applyAllPassengersAreCompliant();
                                }
                            },  
                            cancel:{
                                label: "Cancel",
                                className: "btn-default",
                                callback: function(){}
                            }
                        }
                    });
                }
                
            }

            /**
             * Reset all synced luggage compliance reports of this flight and refresh
             */
            function resetSyncedConfirm(){
                bootbox.dialog({
                    message: '<i class="fa fa-exclamation-triangle text-orange"></i> Reset synced reports.',
                    title: "Confirm",
                    buttons: {
                        confirm:{
                            label: 'Confirm',
                            className: "btn-warning",
                            callback: function(){
                                resetAll();
                                getLuggageCompliancePassengers();
                            }
                        },  
                        cancel:{
                            label: "Cancel",
                            className: "btn-default",
                            callback: function(){}
                        }
                    }
                });
            }
            
            /**
             * Reset all pendings luggage compliance reports of this flight and refresh
             */
            function resetConfirm(){
                bootbox.dialog({
                    message: '<i class="fa fa-exclamation-triangle text-orange"></i> Reset all pending reports of passengers with 2 items on board.',
                    title: "Confirm",
                    buttons: {
                        confirm:{
                            label: 'Confirm',
                            className: "btn-warning",
                            callback: function(){
                                resetAllPendings();
                                getLuggageCompliancePassengers();
                            }
                        },  
                        cancel:{
                            label: "Cancel",
                            className: "btn-default",
                            callback: function(){}
                        }
                    }
                });
            }

            /**
             * Create or remove pending AllPassengersAreCompliant report of this flight
             */
            function applyAllPassengersAreCompliant(){
                if(scope.flightCompliant.HasPendingsReports || scope.flightCompliant.Status === 'pending'){
                    resetAllPendings();
                }
                if(!scope.flightCompliant.IsFlightCompliant){
                    applyFlightComplianceReport();
                }
                getLuggageCompliancePassengers();
            }

            function applyFlightComplianceReport(){
                var cabinLuggageReport = {
                    PNR : '',
                    UCI : '',
                    FlightId : scope.flight.FlightId,
                    FareFamily: '',
                    IsFlightCompliant: true,
                    Created: moment()
                };
                LuggageComplianceFactory.saveFlightIsCompliantToStorage(cabinLuggageReport);
            }
            
            function resetAllPendings(){
                LuggageComplianceFactory.removePendingsLuggageCompliance(scope.flight.FlightId);
            }
            /**
             * Deletes all luggage compliance reports of this flight from DB and from local storage
             */
            function resetAll(){
                if(scope.isOffline){
                    scope.showPanel = "offline";
                }
                else{
                    scope.showPanel = "loading";
                    LuggageComplianceFactory.deleteAllLuggageComplianceReportsByFlightId(scope.flight.FlightId)
                        .then(res => handleSubmitResponse(res));
                }
            }
            
            /**
             * Submit pending luggage compliance reports of this flight
             */
            function submit(){
                var flightId = scope.flight.FlightId;
                if(scope.isOffline){
                    scope.showPanel = "offline";
                }
                else{
                    scope.showPanel = "loading";
                    LuggageComplianceFactory.submitLuggageCompliance(flightId)
                        .then(res => handleSubmitResponse(res));
                }
            }

            /**
             * Manage API response
             * @param {object} res 
             */
            function handleSubmitResponse(res) {
                getLuggageCompliancePassengers();
                if (res.success) {
                    manageResponseMessage("success", res.message);
                    $timeout(function () { scope.showPanel = "luggageCompliance"; }, 6000);
                }
                else {
                    manageResponseMessage("failure", res.message);
                }
            }

            /**
             * Manage message alerts
             * @param {string} panelToShow 
             * @param {string} message 
             */
            function manageResponseMessage(panelToShow, message) {
                scope.submitMessage = message;
                scope.showPanel = panelToShow;
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/LuggageCompliance/twoLuggageEvents.tpl.html',
            scope: false,
            link: link
        }
    }

})();
